"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whitelistCreateConfig = void 0;
exports.whitelistCreateConfig = {
    canCreateLedgerItems: true,
    showCreateWhitelistButton: true,
};
